import React, { useState } from 'react';
import { CardBody, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { useForm } from "react-hook-form";
import Switch from "react-bootstrap-switch";

import { ButtonClean, ButtonSearch, } from "../../../components/buttons/buttonsActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import SelectGeneric from "../../../components/select/selectGeneric";
import {categoryModuleProvider} from "../../../providers/categoryModuleProvider";
import { setFilter } from "../../../redux/actions/generics/IndexedActions";

const ModuleFilters = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { filter } = componentState?.data;

    const [status, setStatus] = useState(filter?.item?.status !== undefined ? filter?.item?.status : null);
    const [categoryModuleId, setCategoryModuleId] = useState( null);

    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            ...data,
            enabled : status
        };

        if (categoryModuleId !== undefined && categoryModuleId !== null && categoryModuleId !== '')
            dataFilter.categoryModule = { id : categoryModuleId };

        props.setFilter(path, dataFilter);
    };

    const cleanFields = () => {
        setCategoryModuleId(null);
        setStatus(null);
        reset({
            code: '',
            name: ''
        });

        props.setFilter(path, {});
    }

    return (<Form onSubmit={handleSubmit(onSubmit)}>
        <CardBody className="">
            <Row>
                <Col md="3">
                    <FormGroup>
                        <Label>Código</Label>
                        <Input
                            type="text"
                            name="code"
                            placeholder="Filtro por Código"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label>Nombre</Label>
                        <Input
                            type="text"
                            name="name"
                            placeholder="Filtro por Nombre"
                            innerRef={register}
                        />
                    </FormGroup>
                </Col>
                <Col md="3">
                    <FormGroup>
                        <Label htmlFor="categoryModule">Categoría del Módulo</Label>
                        <SelectGeneric
                            initialValue={ categoryModuleId }
                            setExternalValue={ setCategoryModuleId }
                            provider={ categoryModuleProvider }
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label>Activo</Label>
                        <br/>
                        <Switch
                            animate={true}
                            offText={"No"}
                            onText={"Si"}
                            value={status}
                            onChange={ () => setStatus(!status) }
                        />
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md="12" className="d-flex justify-content-center">
                    <ButtonSearch />
                    <ButtonClean onClick={() => cleanFields()} />
                </Col>
            </Row>
        </CardBody>
    </Form>);
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(ModuleFilters)